import type { FillBar } from "@teamna/shared";

/**
 * The fill bar of a session (D38): booked of the places, in one colour, gold when people wait
 * (`fillBar` in `@teamna/shared`). The calendar blocks and the Home Today card draw it with this one
 * component; the place gives the size and the track. The bar is hidden from a screen reader: the
 * caller gives `bar.text` in words (the block's description, the line above the bar).
 */
export function FillBarTrack({ bar, className }: { bar: FillBar; className: string }) {
  return (
    <span aria-hidden="true" data-fill-bar={Math.round(bar.share * 100)} data-fill-tone={bar.tone} className={`block overflow-hidden ${className}`}>
      <span
        className={`block h-full rounded-[inherit] ${bar.tone === "waitlist" ? "bg-late-gold-strong" : "bg-tile-booked"}`}
        style={{ width: `${Math.round(bar.share * 100)}%` }}
      />
    </span>
  );
}
